import client from "apis/config";

export const getPagesApi = async () => {
  return await client.get(`page`);
};

export const updatePagesApi = async (data) => {
  return await client.put(`page`, data);
};